// @ts-check

/** Keep QP inside a following window without limiting world travel.
 * @param {number} worldX @param {number} cameraX
 * @param {number} width @param {number} characterWidth
 */
export function followCamera(worldX, cameraX, width, characterWidth) {
  const space = Math.max(0, width - characterWidth - 12);
  const screenX = worldX - cameraX;
  return worldX - Math.max(space * 0.28, Math.min(space * 0.66, screenX));
}

